import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { otpModalState } from '../../recoil/otp/otpModalAtom';
import SCREEN_SIZES from '../../constants/screenSizes';
import MyPageIconButton from './MyPageIconButton';
import * as Sentry from '@sentry/react';

const MyPageToggleButtonGroup = ({ isLogin }) => {
  const [myPageToggleShow, setMyPageToggleShow] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth <= SCREEN_SIZES.MOBILE_SCREEN_WIDTH);
  const toggleMyButtonRef = useRef();

  const setOtpModalState = useSetRecoilState(otpModalState);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const clearSession = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('exp');
    Sentry.setUser(null);
  };

  const handleToggleMyPage = () => {
    setMyPageToggleShow(!myPageToggleShow);
  };

  const handleClickOutside = (event) => {
    // 클릭된 요소가 토글 버튼의 자식이 아니면서 토글 버튼이 열려있을 때
    if (toggleMyButtonRef.current && !toggleMyButtonRef.current.contains(event.target) && myPageToggleShow) {
      setMyPageToggleShow(false);
    }
  };

  const goPurchaseHistory = () => {
    navigate('/purchase-history');
  };

  const goStarbeatHistory = () => {
    navigate('/starbeat-history');
  };

  const handleLogin = () => {
    setOtpModalState(true);
  };

  const handleLogout = () => {
    clearSession();
    window.location.reload();
  };

  const handleMyPage = () => {
    if (!isLogin) {
      handleLogin();
    } else if (isMobileScreen) {
      handleLogout();
    } else {
      handleToggleMyPage();
    }
  };

  useEffect(() => {
    // 마운트될 때 이벤트 리스너 추가
    document.addEventListener('mousedown', handleClickOutside);

    // 언마운트될 때 이벤트 리스너 정리
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [myPageToggleShow]);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileScreen(window.innerWidth <= SCREEN_SIZES.MOBILE_SCREEN_WIDTH);
    };

    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return (
    <>
      <div
        className={`toggle-button-group mypage-toggle-button-group ${myPageToggleShow ? 'is-active' : ''}`}
        ref={toggleMyButtonRef}
      >
        <button
          type={'button'}
          className={'button-default language-toggle-button mypage-toggle-button'}
          aria-label={isLogin ? t('my_page') : t('login')}
          onClick={() => {
            handleMyPage();
          }}
        >
          <i className={`icon icon-person ${isLogin && isMobileScreen ? 'icon-logout' : ''}`} />
        </button>
        <div className={'toggle-content-wrapper'}>
          <ul className={'toggle-content-group'}>
            <li className={'toggle-content-list'}>
              <MyPageIconButton
                onClick={goPurchaseHistory}
                iconClassName='icon-history'
                buttonTxt={t(`purchase_history`)}
              />
            </li>
            <li className={'toggle-content-list'}>
              <MyPageIconButton
                onClick={goStarbeatHistory}
                iconClassName='icon-starbeat'
                buttonTxt={t(`star_beat_history`)}
              />
            </li>
            <li className={'toggle-content-list'}>
              <MyPageIconButton onClick={handleLogout} iconClassName='icon-logout' buttonTxt={t(`logout`)} />
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default MyPageToggleButtonGroup;
